export default {
  setPredicates: (state, predicates) => {
    state.suggest = predicates;
  },
  flush: (state) => {
    state.suggest = [];
  }
};
